import { call, put, select, takeLeading } from 'redux-saga/effects';

import * as $app from 'modules/app';
import * as api from '../api';
import * as actions from '../actions';
import * as selectors from '../selectors';

const verifyEmail = function* ({ payload }) {
  const { data, callbacks } = payload;

  try {
    const { email, hash } = data;
    const token = yield select(selectors.getToken);
    yield call(api.verifyEmail, { email, hash }, { token });
    yield put(actions.setUserEmailVerified());

    yield put($app.updateOnboardingSteps());

    callbacks.onSuccess();
  } catch {
    callbacks.onError();
  }
};

const sendVerificationEmail = function* ({ payload }) {
  const { callbacks } = payload;

  try {
    const token = yield select(selectors.getToken);
    const publisherID = yield select(selectors.getSelectedPublisherId);
    yield call(api.sendVerificationEmail, { token, publisherID });

    callbacks.onSuccess();
  } catch {
    callbacks.onError();
  }
};

export const verifyEmailSaga = function* () {
  yield takeLeading(actions.verifyEmail, verifyEmail);
  yield takeLeading(actions.sendVerificationEmail, sendVerificationEmail);
};
